import { Component, OnInit } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'

import { CommonModule, NgClass, NgIf } from '@angular/common'
import { CaseCreateEditComponent } from '../../../abacus/components/case-create-edit.component'
import { CaseInputComponent } from '../../../abacus/elements/inputs/case-input/case-input.component'
import { Field } from '../../../abacus/interfaces/field.interface'
import { ResourceDefinition } from '../../../abacus/interfaces/resource-definition.interface'
import { BreadcrumbService } from '../../../abacus/services/breadcrumb.service'
import { FlashMessageService } from '../../../abacus/services/flash-message.service'
import { ResourceService } from '../../../abacus/services/resource.service'
import { HasPermissionDirective } from '../../../abacus/standalone-exports'
import { caseCreateEditTemplate } from '../../../abacus/templates/case-create-edit.template'
import { toolDefinition } from '../tool.definition'
import { toolCreateEditFields } from './tool-create-edit.fields'

@Component({
  template: caseCreateEditTemplate,
  standalone: true,
  imports: [
    CommonModule,
    NgIf,
    NgClass,
    ReactiveFormsModule,
    FormsModule,
    HasPermissionDirective,
    CaseInputComponent
  ]
})
export class ToolCreateEditComponent
  extends CaseCreateEditComponent
  implements OnInit
{
  definition: ResourceDefinition = toolDefinition

  fields: Field[] = toolCreateEditFields

  constructor(
    formBuilder: UntypedFormBuilder,
    router: Router,
    activatedRoute: ActivatedRoute,
    resourceService: ResourceService,
    breadcrumbService: BreadcrumbService,
    flashMessageService: FlashMessageService
  ) {
    super(
      formBuilder,
      router,
      breadcrumbService,
      resourceService,
      flashMessageService,
      activatedRoute
    )
  }

  ngOnInit() {
    this.initCreateEditView()
  }
}
